import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IShowCurrentPaymentInfoResponse } from '../types';
import {
  AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_API_URL,
  AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useShowCurrentPaymentInfoQuery(): IContextQueryResult<IShowCurrentPaymentInfoResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IShowCurrentPaymentInfoResponse>({
    queryKey: [AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY],
    queryFn: async ({ signal }) => fetchGet<IShowCurrentPaymentInfoResponse>(
      AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_API_URL,
      {
        signal,
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
